import React, { useContext, useEffect, useState } from "react"

import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import { getPriceAndCurrency } from "@/data/plans"
import { RegionContext } from "@/context/region"

const PlanCardPrice = ({ tier, frequency, discount, compactPrice = false }) => {
  const { t } = useTranslation()
  const { region } = useContext(RegionContext)
  const [hasMounted, setHasMounted] = useState(false)

  const priceClassName = [
    "plan-card__price",
    compactPrice && "plan-card__price--five-plans",
  ]
    .filter(Boolean)
    .join(" ")

  useEffect(() => {
    setHasMounted(true)
  }, [])

  const { price, currency, discountedPrice } = getPriceAndCurrency(
    tier,
    frequency,
    hasMounted ? region : null,
    discount,
  )

  const isLatam = region === "LA"
  const paidPlanBillingLabel = t("plans.per-user-per-month")

  if (!hasMounted) {
    return (
      <div className={priceClassName}>
        <div className="plan-card__cost loading-indicator">
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
        <span className="ml-2 p--xs plan-card__label">
          {tier === "free" ? (
            <>{t("plans.max-2-users")}</>
          ) : (
            <>
              {paidPlanBillingLabel}
              <br />
              {frequency === "MONTHLY"
                ? t("plans.billed-monthly")
                : t("plans.billed-annually")}
            </>
          )}
        </span>
      </div>
    )
  }

  return (
    <div className={priceClassName}>
      {tier === "free" ? (
        <span className="plan-card__cost">
          <sup className="plan-card__currency">{currency}</sup>
          <span className="plan-card__value">0</span>
        </span>
      ) : discount && !isLatam ? (
        <div>
          <span className="plan-card__cost plan-card__cost--discounted">
            <sup className="plan-card__currency">{currency}</sup>
            <span className="plan-card__value">{price}</span>
          </span>
          <span className="ml-3 plan-card__cost">
            <sup className="plan-card__currency">{currency}</sup>
            <span className="plan-card__value">{discountedPrice}</span>
          </span>
        </div>
      ) : (
        <span className="plan-card__cost">
          <sup className="plan-card__currency">{currency}</sup>
          <span className="plan-card__value">{price}</span>
        </span>
      )}

      <span className="ml-2 p--xs plan-card__label">
        {tier === "free" ? (
          <>{t("plans.max-2-users")}</>
        ) : (
          <>
            {paidPlanBillingLabel}
            <br />
            {frequency === "MONTHLY"
              ? t("plans.billed-monthly")
              : t("plans.billed-annually")}
          </>
        )}
      </span>
    </div>
  )
}

export default PlanCardPrice
